import React from 'react';
import styles from './HowItWorks.module.css';

const DEFAULT_SUBTITLE = 'One subscription covers evaluation, medication, and ongoing support.';

const DEFAULT_STEPS = [
    { num: 'Step 1', title: 'Submit your intake', body: "From your phone in just a few minutes. We'll ask about your health history and goals.", tag: '5 minutes' },
    { num: 'Step 2', title: 'Clinician review', body: 'A licensed clinician reviews your information and decides whether treatment is appropriate.', tag: 'Within 24 hours' },
    { num: 'Step 3', title: 'If prescribed, fulfillment', body: 'Your medication is dispensed by a state-licensed pharmacy and shipped — refrigerated where required.', tag: 'Free shipping', featured: true },
    { num: 'Step 4', title: 'Ongoing support', body: 'Message your care team anytime. Dose adjustments are clinician-guided and included.', tag: 'Cancel anytime' },
];

export default function HowItWorks({ steps = DEFAULT_STEPS, subtitle = DEFAULT_SUBTITLE }) {
    return (
        <section className={styles.how}>
            <div className={styles.howInner}>
                <div className={styles.howHead}>
                    <div className={styles.howEyebrow}>How it works</div>
                    <h2>From intake to ongoing care, in four simple steps</h2>
                    <p>{subtitle}</p>
                </div>
                <div className={styles.howSteps}>
                    {steps.map((step) => (
                        <div key={step.num} className={`${styles.howStep} ${step.featured ? styles.howStepFeatured : ''}`}>
                            <div className={styles.howNum}>{step.num}</div>
                            <h4>{step.title}</h4>
                            <p>{step.body}</p>
                            <span className={styles.howTag}>{step.tag}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
